import { Outlet } from 'react-router-dom'
import Navbar from './Navbar'
import Footer from './Footer'
import { BannerAd, AD_SLOTS } from './ads'

function Layout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      {/* Footer Banner Ad */}
      <BannerAd
        slot={AD_SLOTS.LAYOUT_FOOTER}
        format="horizontal"
        className="flex justify-center"
        wrapperClassName="bg-gray-100 py-4 container-responsive"
      />
      <Footer />
    </div>
  )
}

export default Layout
